/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import * as b64$ from "../lib/base64.js";
import { ClosedEnum } from "../types/enums.js";

/**
 * 压缩强度 (1-5)，默认为 3。数字越小，压缩率越高。
 */
export const PostImageCompressLevel = {
  One: 1,
  Two: 2,
  Three: 3,
  Four: 4,
  Five: 5,
} as const;
/**
 * 压缩强度 (1-5)，默认为 3。数字越小，压缩率越高。
 */
export type PostImageCompressLevel = ClosedEnum<typeof PostImageCompressLevel>;

export const PostImageCompressLevel$zodSchema = z.union([
  z.literal(1),
  z.literal(2),
  z.literal(3),
  z.literal(4),
  z.literal(5),
]).describe("压缩强度 (1-5)，默认为 3。数字越小，压缩率越高。");

/**
 * 输出图片格式，可以是 'png' 或 'jpeg'。
 */
export const PostImageCompressFormat = {
  Png: "png",
  Jpeg: "jpeg",
} as const;
/**
 * 输出图片格式，可以是 'png' 或 'jpeg'。
 */
export type PostImageCompressFormat = ClosedEnum<
  typeof PostImageCompressFormat
>;

export const PostImageCompressFormat$zodSchema = z.enum([
  "png",
  "jpeg",
]).describe("输出图片格式，可以是 'png' 或 'jpeg'。");

export type PostImageCompressFile = {
  fileName: string;
  content: Uint8Array | string;
};

export const PostImageCompressFile$zodSchema: z.ZodType<PostImageCompressFile> =
  z.object({
    content: z.string().describe("Base64-encoded binary content").transform(
      b64$.bytesFromBase64,
    ),
    fileName: z.string(),
  });

export type PostImageCompressRequestBody = {
  file: PostImageCompressFile | Blob;
};

export const PostImageCompressRequestBody$zodSchema: z.ZodType<
  PostImageCompressRequestBody
> = z.object({
  file: z.lazy(() => PostImageCompressFile$zodSchema),
});

export type PostImageCompressRequest = {
  level?: PostImageCompressLevel | undefined;
  format?: PostImageCompressFormat | undefined;
  body: PostImageCompressRequestBody;
};

export const PostImageCompressRequest$zodSchema: z.ZodType<
  PostImageCompressRequest
> = z.object({
  body: z.lazy(() => PostImageCompressRequestBody$zodSchema),
  format: PostImageCompressFormat$zodSchema.default("png"),
  level: PostImageCompressLevel$zodSchema.default(3),
});

/**
 * 服务器内部错误。压缩过程中发生错误。
 */
export type PostImageCompressInternalServerErrorResponseBody = {
  code?: string | undefined;
  message?: string | undefined;
};

export const PostImageCompressInternalServerErrorResponseBody$zodSchema:
  z.ZodType<PostImageCompressInternalServerErrorResponseBody> = z.object({
    code: z.string().optional(),
    message: z.string().optional(),
  }).describe("服务器内部错误。压缩过程中发生错误。");

/**
 * 请求无效。可能是未上传文件、文件格式不受支持或参数错误。
 */
export type PostImageCompressBadRequestResponseBody = {
  code?: string | undefined;
  message?: string | undefined;
};

export const PostImageCompressBadRequestResponseBody$zodSchema: z.ZodType<
  PostImageCompressBadRequestResponseBody
> = z.object({
  code: z.string().optional(),
  message: z.string().optional(),
}).describe("请求无效。可能是未上传文件、文件格式不受支持或参数错误。");

export type PostImageCompressResponseResult =
  | Uint8Array
  | string
  | PostImageCompressBadRequestResponseBody
  | PostImageCompressInternalServerErrorResponseBody;

export const PostImageCompressResponseResult$zodSchema: z.ZodType<
  PostImageCompressResponseResult
> = z.union([
  z.string().describe("Base64-encoded binary content").transform(
    b64$.bytesFromBase64,
  ),
  z.lazy(() => PostImageCompressBadRequestResponseBody$zodSchema),
  z.lazy(() => PostImageCompressInternalServerErrorResponseBody$zodSchema),
]);

export type PostImageCompressResponse = {
  Headers: { [k: string]: Array<string> };
  Result:
    | Uint8Array
    | string
    | PostImageCompressBadRequestResponseBody
    | PostImageCompressInternalServerErrorResponseBody;
};

export const PostImageCompressResponse$zodSchema: z.ZodType<
  PostImageCompressResponse
> = z.object({
  Headers: z.record(z.string(), z.array(z.string())).default({}),
  Result: z.union([
    z.string().describe("Base64-encoded binary content").transform(
      b64$.bytesFromBase64,
    ),
    z.lazy(() => PostImageCompressBadRequestResponseBody$zodSchema),
    z.lazy(() => PostImageCompressInternalServerErrorResponseBody$zodSchema),
  ]),
});
